import { render, staticRenderFns } from "./invite-ruzhi-dialog.vue?vue&type=template&id=06c062e0&scoped=true"
import script from "./invite-ruzhi-dialog.vue?vue&type=script&lang=js"
export * from "./invite-ruzhi-dialog.vue?vue&type=script&lang=js"
import style0 from "./invite-ruzhi-dialog.vue?vue&type=style&index=0&id=06c062e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c062e0",
  null
  
)

export default component.exports